import { PageRef } from 'providers/page-ref';

/** The hub takes no navigation parameters — everything it shows is fetched for the signed-in caller. */
export type ReferralHubPageParams = {};

export const IReferralHubPage: PageRef<ReferralHubPageParams, void> = {
  pageName: 'ReferralHubPage',
} as PageRef<ReferralHubPageParams, void>;
